// extracted by mini-css-extract-plugin
export default {"skills-section":"Skills_skills-section__pSDqa","title":"Skills_title__Q+7Gb"};